// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 495) return "homepage-slider.95671f.js";
	if (chunkId === 982) return "product-detail.488200.js";
	if (chunkId === 188) return "slideshow-related-items.4e9e07.js";
	if (chunkId === 937) return "product-archive.ac0259.js";
	if (chunkId === 820) return "recipe-archive.9348d6.js";
	if (chunkId === 836) return "6-for-60.829a67.js";
	if (chunkId === 316) return "how-to-buy.81e45c.js";
	if (chunkId === 823) return "panel-resources.5f4560.js";
	if (chunkId === 580) return "view-switcher.5e68ce.js";
	if (chunkId === 759) return "image-over-video.3b11af.js";
	if (chunkId === 822) return "sticky-nav.1cee92.js";
	if (chunkId === 2) return "search-ui.3ddbe4.js";
	if (chunkId === 322) return "slideshow-products.e3c595.js";
	// return url for filenames based on template
	return undefined;
};